import { Stack } from "@mui/material";
import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";

interface MarkdownRendererProps {
  url: string;
}

export default function MarkdownRenderer({
  url,
}: MarkdownRendererProps): JSX.Element {
  const [info, setInfo] = useState<string>("");

  useEffect(() => {
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        setInfo(text);
      });
  }, [url]);

  return (
    <Stack p={1}>
      <ReactMarkdown children={info} />
    </Stack>
  );
}
